export default __webpack_public_path__ + "static/media/Access-documentation.f57216f5.md";